var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"storage-usage"},[_c('div',{staticClass:"amountUsage",style:(`width: ${_setup.percent}%`)}),_c('div',{staticClass:"usageLabel"},[_vm._v(" Storage Used "+_vm._s(_setup.percent < 1 ? '< 1' : _setup.percent)+"% ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }